import { render } from "./PriceEvolutionModal.vue?vue&type=template&id=b37a3f7a&ts=true"
import script from "./PriceEvolutionModal.ts?vue&type=script&lang=ts"
export * from "./PriceEvolutionModal.ts?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/RC.Estimatifs/rc-estimatifs-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__